const uris = {
    development: {
        // Prod server....
        public: "https://api.v3.invintusmedia.com/V2/",
        crud: "https://crud.v3.invintusmedia.com/",
        // Actual Dev Server
        // public: "//216.186.43.88:8888/V2/",
        // crud: "//216.186.43.88:8887/",
        analytics: "https://analytics.invintusmedia.com"
    },
    production: {
        public: "https://api.v3.invintusmedia.com/V2/",
        crud: "https://crud.v3.invintusmedia.com/",
        analytics: "https://analytics.invintusmedia.com"
    }
};
const Auth0 = {
    auth0_redirect_development: 'http://localhost:3000/',
    auth0_redirect_production: 'https://controlcenter.invintusmedia.com/Auth/verify',
    auth0_change_password_uri: 'https://invintus.auth0.com/dbconnections/change_password',
    auth0_domain: 'auth.invintusmedia.com',
    auth0_scope: 'openid profile email',
    auth0_client_v2: 'XpoC1ful73N9QFfLH3UOuq36YWwrPvyM',
    auth0_client_ent_oregon: 'oOZtG9qRPajkEp2eWqilxK2y9sFinFlk',
    auth0_secret_ent_oregon: 'FvlMZ_-4I0PWMsCOim3HPRFQ7eRO0_KPh0sph29Tp9gfEXdnPVBnuny1tNNSp-sU',
    auth0_redirect_ent_oregon: 'https://oregon-legis.invintusmedia.com/Auth/verify',
    auth0_subdomain_ent_oregon: 'oregon-legis'
}
export default {
    // Auth0
    Auth0: Auth0,
    // @deprecated
    scaledroneKey: "rFYOtL5b7Wqeu7Y2",
    // ...
    AwsWebSocketUri: 'wss://2gljbu4vrj.execute-api.us-west-2.amazonaws.com',
    apiAuthentication: {
        vendorName: "console",
        vendorKey: "WTw0fEUjXau3J5e79L6iycALE2456sRef9i0vw5kU",
        analyticsKey: '7WmdkuQ8o4kL6X6rzCuqahmfT',
        analyticsAuthentication: 'KvqPoHG2MH4YsbKpP468XGHHs'
    },
    chat: {
        // to find these routes go to API gateway find the event-chat gateways
        // then go to the Dashboard tab (on the left column) and note the "Invoke this API at: ..."
        // rest: 'https://054wuiu065.execute-api.us-west-2.amazonaws.com/Test/',
        // websocket: 'wss://m1wzxei7ee.execute-api.us-west-2.amazonaws.com/Test/',
        rest: 'https://odq9lh6602.execute-api.us-west-2.amazonaws.com/Prod/',
        websocket:  'wss://23i5fw32bg.execute-api.us-west-2.amazonaws.com/Prod/',
        page: 'https://chatadmin.invintus.com/?'
    },
    aws: {
        accessKeyId: 'AKIAVRVR6VH5YNKDHVL2',
        secretAccessKey: "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",
        bucket: (process.env.NODE_ENV == 'development') ?
            "invintus-dev-uploads" :
            "invintus-uploads"
    },
    analytics: {
        client: "146001447830-0s2gs3j4rhse9ndgl2n7kb6m57h1bgd1.apps.googleusercontent.com",
        reportID: "ga:77774325",
    },
    apps: {
        audioDescriptionStudio: 'https://audio-descriptions.invintus.com'
    },
    uris: uris[process.env.NODE_ENV]
};
